import React, { useState } from "react";
import "./GrowthPriorities.css";

const priorities = [
    {
        id: 1,
        index: "01",
        title: "Product Engineering",
        tag: "End-to-End Systems",
        desc: "From concept to deployable UAV platforms — every system engineered for mission-critical reliability.",
        details: ["Custom Airframes", "Payload Integration", "Performance Tuning", "Aerodynamic Optimization"],
    },
    {
        id: 2,
        index: "02",
        title: "Hardware Development",
        tag: "Precision Hardware",
        desc: "In-house PCB design, flight controllers, power systems, sensors, and GPS — built for reliable UAV platforms.",
        details: ["PCB Design", "Flight Controllers", "Sensor Integration", "Power Systems"],
    },
    {
        id: 3,
        index: "03",
        title: "Software & Firmware",
        tag: "Embedded Intelligence",
        desc: "Custom flight firmware, ground control integration, mission planning tools, and telemetry dashboards.",
        details: ["Custom Firmware", "GCS Integration", "Mission Planning", "Mobile GCS"],
    },
    {
        id: 4,
        index: "04",
        title: "Manufacturing & Quality",
        tag: "Production Excellence",
        desc: "Scalable manufacturing with strict QA pipelines — every drone leaves our lab flight-proven.",
        details: ["Flight Testing", "System Calibration", "Safety Validation", "Pre-Deployment QA"],
    },
];

/* Inline detail — pure CSS max-height animation */
function NodeDetail({ item, isOpen }) {
    return (
        <div
            className={`gp-node-detail${isOpen ? " gp-node-detail--open" : ""}`}
            aria-hidden={!isOpen}
        >
            <div className="gp-node-detail-inner">
                {item.details.map((label, i) => (
                    <div
                        className="gp-detail-item"
                        key={i}
                        style={{ transitionDelay: isOpen ? `${i * 0.07}s` : "0s" }}
                    >
                        <div className="gp-detail-dot" />
                        <div className="gp-detail-label">{label}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default function GrowthPriorities() {
    const [activeId, setActiveId] = useState(null);

    const toggle = (id) => setActiveId((prev) => (prev === id ? null : id));

    const activeItem = priorities.find((p) => p.id === activeId);

    return (
        <section className="gp-wrap">
            <div className="gp-bg-grid" />

            <div className="gp-inner">

                {/* ── Header ── */}
                <div className="gp-header">
                    <div className="gp-eyebrow">
                        <span className="gp-dot" />
                        Core Capabilities
                    </div>
                    <h2 className="gp-h2">
                        Growth
                        <em>Priorities</em>
                    </h2>
                </div>

                {/* ── Timeline ── */}
                <div className="gp-timeline">
                    <div className="gp-track-line" />

                    {priorities.map((item) => (
                        <div
                            key={item.id}
                            className={`gp-node${activeId === item.id ? " gp-node--active" : ""}`}
                        >
                            {/* index */}
                            <div className="gp-node-index">{item.index}</div>

                            {/* dot */}
                            <div className="gp-node-dot-wrap">
                                <div className="gp-node-ring" />
                                <div className="gp-node-dot" />
                            </div>

                            {/* card */}
                            <div
                                className="gp-node-card"
                                onClick={() => toggle(item.id)}
                            >
                                <div className="gp-node-accent" />
                                <div className="gp-node-ghost">{item.index}</div>

                                <span className="gp-node-tag">{item.tag}</span>
                                <h3 className="gp-node-title">{item.title}</h3>
                                <p className="gp-node-desc">{item.desc}</p>

                                <div className="gp-node-arrow">
                                    {activeId === item.id ? "COLLAPSE" : "EXPLORE"} →
                                </div>
                            </div>

                            {/* ── MOBILE: inline detail expands right below this card ── */}
                            <div className="gp-node-inline-detail">
                                <NodeDetail item={item} isOpen={activeId === item.id} />
                            </div>
                        </div>
                    ))}
                </div>

                {/* ── DESKTOP: shared detail panel below the full timeline ── */}
                <div className={`gp-detail gp-detail--desktop${activeId ? " gp-detail--open" : ""}`}>
                    {activeItem && (
                        <div className="gp-detail-inner">
                            {activeItem.details.map((label, i) => (
                                <div
                                    className="gp-detail-item"
                                    key={i}
                                    style={{ transitionDelay: `${i * 0.06}s` }}
                                >
                                    <div className="gp-detail-dot" />
                                    <div className="gp-detail-label">{label}</div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* ── Hint ── */}
                <p className="gp-hint">
                    {activeId ? "— click again to collapse —" : "— click any box to explore —"}
                </p>

            </div>
        </section>
    );
}